// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const MagnifyingGlass_Filled_Stroke2_Corner0_Rounded =
  createSinglePathSVG({
    path: 'M15.75 10.5a5.25 5.25 0 1 1-5.25-5.25 5.25 5.25 0 0 1 5.25 5.25Zm5.78 11.03a.75.75 0 0 1-1.06 0l-4.694-4.693a8.25 8.25 0 1 1 1.061-1.06l4.694 4.692a.75.75 0 0 1 0 1.062ZM10.5 17.25a6.75 6.75 0 1 0-6.75-6.75 6.76 6.76 0 0 0 6.75 6.75Z',
    viewBox: '0 0 24 24',
    glyph: 'MagnifyingGlass_Filled_Stroke2_Corner0_Rounded',
  })

export const MagnifyingGlass_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'm21.53 20.47-4.693-4.694a8.26 8.26 0 1 0-1.06 1.06l4.692 4.695a.75.75 0 0 0 1.062-1.062ZM3.75 10.5a6.75 6.75 0 1 1 6.75 6.75 6.76 6.76 0 0 1-6.75-6.75Z',
  viewBox: '0 0 24 24',
  glyph: 'MagnifyingGlass_Stroke2_Corner0_Rounded',
})

export const MagnifyingGlassX_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M14.25 10.5a.75.75 0 0 1-.75.75h-6a.75.75 0 0 1 0-1.5h6a.75.75 0 0 1 .75.75Zm7.28 11.03a.75.75 0 0 1-1.06 0l-4.694-4.693a8.26 8.26 0 1 1 1.06-1.06l4.695 4.692a.75.75 0 0 1 0 1.062ZM10.5 17.25a6.75 6.75 0 1 0-6.75-6.75 6.76 6.76 0 0 0 6.75 6.75Z',
  viewBox: '0 0 24 24',
  glyph: 'MagnifyingGlassX_Stroke2_Corner0_Rounded',
})

export const MagnifyingGlassX_Stroke2_Corner0_Rounded_Large =
  createSinglePathSVG({
    path: 'M57.415 54.585 44.898 42.07a22.028 22.028 0 1 0-2.828 2.828l12.515 12.517a2.001 2.001 0 0 0 2.83-2.83ZM10 28a18 18 0 1 1 18 18 18.02 18.02 0 0 1-18-18Z',
    viewBox: '0 0 64 64',
    glyph: 'MagnifyingGlassX_Stroke2_Corner0_Rounded_Large',
  })
